import Highcharts from 'highcharts';
import { installGlobalBoostLineHighlight } from '../../helper/boost-line-highlight';

export const textStyle = {
  style: {
    color: 'var(--primary)',
  },
};

export const DEFAULT_SERIE = {
  stickyTracking: false,
  tooltip: {
    valueDecimals: 2,
    followTouchMove: true,
    followPointer: true,
  },
};

export const DEFAULT_LINE_COLORS = {
  lineColor: 'var(--chart-lines)',
  tickColor: 'var(--chart-lines)',
  gridLineColor: 'var(--chart-lines)',
};

export const DEFAULT_CHART_OPTIONS: Highcharts.Options = {
  title: {
    style: {
      ...textStyle.style,
      'font-size': '1em',
    },
    text: undefined,
  },
  chart: {
    type: 'line',
    zooming: {
      type: 'xy',
    },
    backgroundColor: 'var(--card)',
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%e %b',
    },
    labels: { ...textStyle },
    ...DEFAULT_LINE_COLORS,
  },
  yAxis: {
    title: {
      ...textStyle,
    },
    labels: {
      ...textStyle,
      formatter: function () {
        return `${this.value}`;
      },
    },
    ...DEFAULT_LINE_COLORS,
  },
  legend: {
    title: {
      ...textStyle,
    },
    itemStyle: {
      color: 'var(--primary)',
    },
    itemHoverStyle: {
      color: 'var(--primary)',
    },
    verticalAlign: 'top',
  },
  tooltip: {
    followPointer: true,
    followTouchMove: true,
  },
  credits: { enabled: false },
  exporting: {
    enabled: false,
    sourceWidth: 2056,
    sourceHeight: 400,
    buttons: {
      contextButton: {
        enabled: false,
        className: 'export-button',
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF'],
        symbol: '',
        useHTML: true,
        theme: {
          fill: 'var(--background-export)',
        },
        text: `
          <i class="far fa-download font-icons pointer mr-2 mt-1 text-primary"></i>
          <span class="pointer text-primary" > Export </span>
          <i class="fas cursor-pointer text-primary ml-2 mt-1 font-size-small fa-chevron-down"></i>
        `,
      },
    },
    chartOptions: {
      chart: {
        backgroundColor: 'white',
      },
    },
  },
  boost: {
    enabled: true,
    useGPUTranslations: false,
    allowForce: true,
  },
  series: [],
};

export const CURTAILMENT_OPTIONS: Highcharts.Options = {
  plotOptions: {
    area: {
      marker: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      fillColor: {
        pattern: {
          path: {
            d: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
            strokeWidth: 2,
          },
          width: 10,
          height: 10,
          opacity: 0.4,
        },
      },
    },
    series: {
      marker: {
        enabled: false,
      },
    },
  },
};

function initModule(module: any) {
  if (!module) return;
  if (typeof module.default === 'function') {
    module.default(Highcharts);
  } else if (typeof module === 'function') {
    module(Highcharts);
  }
}

export async function loadHighchartsModules() {
  installGlobalBoostLineHighlight();
  const modules = await Promise.all([
    await import('highcharts/highcharts-more'),
    await import('highcharts/modules/boost'),
  ]);
  modules.forEach(initModule);
}
